import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { JJUnicorn_Video1 } from '../../../../../utils/ES/Modals/aiArtists';

const ModalVideoJJUnicorn1 = () => {
  return (
    <>
      <ModalVideo
        id="jj-unicorn-video-1"
        dataText={JJUnicorn_Video1}
        videoSrc="https://player.vimeo.com/video/1213385663?badge=0&autopause=0&player_id=0&app_id=58479"
        videoTitle="KUTER_STUDIO_AI_JJUNICORN_VIDEO_1"
      />
    </>
  );
};

export default ModalVideoJJUnicorn1;
